import React from "react";
import { connect } from "react-redux";
import "./_Ring.scss";
import { withRouter } from "react-router-dom";
import queryString from "query-string";

class Ring extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  onHover = (isHover) => {
    this.setState((prevState) => ({
      isHovered: isHover,
    }));
  };

  getCurrentMaterial = (mainRing = true) => {
    const { history } = this.props;
    const queryParams = history
      ? queryString.parse(history.location.search)
      : null;
    if (queryParams) {
      if (mainRing) {
        return queryParams["ring-material"];
      } else {
        return queryParams["holder-material"];
      }
    }
  };

  renderRing = () => {
    const { activeMainRing, activeHolderRings } = this.props;
    const currentMainRingMaterial = this.getCurrentMaterial();
    const currentHolderRingMaterial = this.getCurrentMaterial(false);
    let mainRingHeight = 0;
    if (currentMainRingMaterial) {
      let ringImageUrl = null;
      let diamondImageUrl = null;
      let mainRingShadowUrl = null;
      if (activeMainRing) {
        mainRingHeight = activeMainRing.fields.ringHeight
          ? activeMainRing.fields.ringHeight
          : 0;
        switch (currentMainRingMaterial) {
          case "yellow-gold":
            ringImageUrl = activeMainRing.fields.imageYellowGoldURL;
            diamondImageUrl = activeMainRing.fields.imageYellowGoldDiamondURL;
            mainRingShadowUrl = activeMainRing.fields.imageYellowGoldShadowURL;
            break;
          case "rose-gold":
            ringImageUrl = activeMainRing.fields.imageRoseGoldURL;
            diamondImageUrl = activeMainRing.fields.imageRoseGoldDiamondURL;
            mainRingShadowUrl = activeMainRing.fields.imageRoseGoldShadowURL;
            break;
          case "white-gold":
            ringImageUrl = activeMainRing.fields.imageWhiteGoldURL;
            diamondImageUrl = activeMainRing.fields.imageWhiteGoldDiamondURL;
            mainRingShadowUrl = activeMainRing.fields.imageWhiteGoldShadowURL;
            break;
          case "platinum":
            ringImageUrl = activeMainRing.fields.imagePlatinumURL;
            diamondImageUrl = activeMainRing.fields.imagePlatinumDiamondURL;
            mainRingShadowUrl = activeMainRing.fields.imagePlatinumShadowURL;
            break;
          default:
            ringImageUrl = activeMainRing.fields.imageYellowGoldURL;
            diamondImageUrl = activeMainRing.fields.imageYellowGoldDiamondURL;
            mainRingShadowUrl = activeMainRing.fields.imageYellowGoldShadowURL;
            break;
        }
      }
      let holderRingImageUpper = null;
      let holderRingImageLower = null;
      let holderRingShadow = null;
      if (activeHolderRings) {
        switch (currentHolderRingMaterial) {
          case "yellow-gold":
            holderRingImageUpper =
              activeHolderRings.fields.imageYellowGoldUpperURL;
            holderRingImageLower =
              activeHolderRings.fields.imageYellowGoldLowerURL;
            holderRingShadow =
              activeHolderRings.fields.imageYellowGoldShadowURL;
            break;
          case "rose-gold":
            holderRingImageUpper =
              activeHolderRings.fields.imageRoseGoldUpperURL;
            holderRingImageLower =
              activeHolderRings.fields.imageRoseGoldLowerURL;
            holderRingShadow = activeHolderRings.fields.imageRoseGoldShadowURL;
            break;
          case "white-gold":
            holderRingImageUpper =
              activeHolderRings.fields.imageWhiteGoldUpperURL;
            holderRingImageLower =
              activeHolderRings.fields.imageWhiteGoldLowerURL;
            holderRingShadow = activeHolderRings.fields.imageWhiteGoldShadowURL;
            break;
          case "platinum":
            holderRingImageUpper =
              activeHolderRings.fields.imagePlatinumUpperURL;
            holderRingImageLower =
              activeHolderRings.fields.imagePlatinumLowerURL;
            holderRingShadow =
              activeHolderRings.fields.imagePlatinumGoldShadowURL;
            break;
          default:
            holderRingImageUpper =
              activeHolderRings.fields.imageYellowGoldUpperURL;
            holderRingImageLower =
              activeHolderRings.fields.imageYellowGoldLowerURL;
            holderRingShadow =
              activeHolderRings.fields.imageYellowGoldShadowURL;
            break;
        }
      }
      const holderUpperClass = this.state.isHovered
        ? "holder-upper hovered"
        : "holder-upper";
      const holderLowerClass = this.state.isHovered
        ? "holder-lower hovered"
        : "holder-lower";
      const shadowClass = this.state.isHovered
        ? "holder-lower shadow hovered"
        : "holder-lower shadow";
      /**
       * 5% top = 2,0mm ring height, 1% top = 4,3mm ring height.
       * 1% = 4.3mm
       * 2% = 3.725mm
       * 3% = 3.15mm
       * 4% = 2.575mm
       * 5% = 2.0mm
       * 4.875 is the slope number
       */
      const holderTopPercentage = (4.875 - mainRingHeight) / 0.575;
      const holderBottom = -holderTopPercentage;
      return (
        <div
          className="ring-images"
          id="rings"
          onMouseLeave={() => this.onHover(false)}
          onMouseEnter={() => this.onHover(true)}
          onClick={() =>
            this.setState((prevState) => ({
              isHovered: !prevState.isHovered,
            }))
          }
        >
          {holderRingImageUpper ? (
            <img
              src={holderRingImageUpper}
              className={holderUpperClass}
              alt="Holder ring upper"
              style={{
                top: `${holderTopPercentage}%`,
              }}
            />
          ) : null}
          {ringImageUrl ? (
            <img src={ringImageUrl} className="main-ring" alt="Main ring" />
          ) : null}
          {diamondImageUrl ? (
            <img
              src={diamondImageUrl}
              className="main-ring-diamond"
              alt="Main ring diamond"
            />
          ) : null}
          {!holderRingImageLower ? (
            mainRingShadowUrl ? (
              <img
                src={mainRingShadowUrl}
                className="main-ring-shadow"
                alt="Main ring shadow"
              />
            ) : null
          ) : null}
          {holderRingImageLower ? (
            <img
              src={holderRingImageLower}
              className={holderLowerClass}
              alt="Holder ring lower"
              style={{
                top: `${holderBottom}%`,
              }}
            />
          ) : null}
          {holderRingShadow ? (
            <img
              src={holderRingShadow}
              className={shadowClass}
              alt="Holder ring shadow"
              style={{
                top: `${holderBottom}%`,
              }}
            />
          ) : null}
        </div>
      );
    }
  };

  render() {
    return <div className="ring">{this.renderRing()}</div>;
  }
}

const mapStateToProps = ({ ring }) => {
  const { activeMainRing, activeHolderRings } = ring;

  return {
    activeMainRing,
    activeHolderRings,
  };
};

export default connect(mapStateToProps, {})(withRouter(Ring));
